/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import sdk from '../../../../sdk';
import Logger from '../../../../services/Logger';

const editTranscriptSpeaker = createAsyncThunk(
  'asset/editTranscriptSpeaker',
  async (
    {
      assetId,
      startTime,
      newSpeaker,
      oldSpeaker,
      revisionId,
    }, { rejectWithValue },
  ) => {
    try {
      await sdk.assets.editTranscriptSpeaker(assetId, revisionId, oldSpeaker, newSpeaker, startTime);
      Logger.log('User', 'TranscriptEditSaved');
      return {
        assetId, newSpeaker, oldSpeaker, startTime, revisionId,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default editTranscriptSpeaker;
